import React from "react"

class PillFilter extends React.Component{
    constructor(){
        super()
        this.state = {
            selected: false,
        }
    }
    handleKeyDown = (e) =>{
        //expand dropdown
        if (e.key === "Enter") this.toggleFilter()
        //submit from keyboard
        if (e.target.id !== this.props.name && (e.key === "Enter" || e.key === " ")) this.toggleFilter()
    }
    toggleFilter = () =>{
        this.setState(prevState =>{
            return {selected: !prevState.selected}
        },()=>this.props.toggleFilter(this.state.selected))
    }
    render(){
        return(
            <div className={`filter ${this.state.selected === true ? "selected" : ""}`} tabIndex="0" 
                onClick={this.toggleFilter} onKeyDown={this.handleKeyDown}>
                    {this.props.filterName}
            </div>
        )
    }
}

export default PillFilter